import type { FC } from 'react';

import {
	BookedRouteDetails,
	IBookedRouteDetailsProps,
} from '../BookedRouteDetails';

import { MoreActionsProvider } from './context';

export const BookingDetails: FC<IBookedRouteDetailsProps> = ({ ...props }) => {
	return (
		<MoreActionsProvider>
			<BookedRouteDetails {...props} />
		</MoreActionsProvider>
	);
};
